import { useState } from 'react';
import { SectionType, TabWrap } from 'sections/TabWrap';

import { FileInput } from 'components/FileInput';

import * as S from './Documents.styles';

export function Documents(): React.ReactElement {
  // eslint-disable-next-line
  const [file, fileSet] = useState<File>();

  const sections: SectionType[] = [
    {
      id: 1,
      content: (
        <S.Container>
          <FileInput onChange={fileSet} />
        </S.Container>
      ),
    },
  ];

  return <TabWrap sections={sections} />;
}
